import React from "react";
import { Helmet } from "react-helmet-async";
import { ldJson } from "./consts.ts";

type StandardPageHeadProps = {
  title: string;
  description: string;
  pageUrl: string;
};

export const StandardPageHead: React.FC<StandardPageHeadProps> = ({
  title,
  description,
  pageUrl,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={pageUrl} />
      <script type="application/ld+json">{ldJson(pageUrl)}</script>
    </Helmet>
  );
};
